import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as fromStore from '../../../store';
import { takeWhile } from 'rxjs/operators';

import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { INDRAMybService } from '@ibe/services';

import { COUNTRY_CODE_PORTUGAL,
		COUNTRY_CODE_BRAZIL,
		LISBON_CODE,
		EXTRAS_ANCILLARY_STOPOVER_AIRPORT_TRANSFERS,
		EXTRAS_ANCILLARY_STOPOVER_LISBOA_CARD,
		EXTRAS_ANCILLARY_STOPOVER_HOTEL,
		EXTRAS_ANCILLARY_STOPOVER_SIGHTSEEING_TOURS,
		SESSION_VAR_KEY_CURRENCY,
		SPECIAL_CASE_MARKET_LANGUAGE_MAP,
		SESSION_VAR_KEY_LANGUAGE,
		DEFAULT_LANGUAGE,
		SESSION_VAR_KEY_MARKET,
		DEFAULT_MARKET} from '@ibe.config';
import { EVENT_PRODUCT_BRAND_HOTELS, INDRAGoogleAnalyticsService, EVENT_ACTION_CLICK } from '@ibe.services/google.analytics.indra.service';

@Component({
	selector: 'app-ticket-stopover',
	templateUrl: './ticket-stopover.indra.component.html',
	styleUrls: ['./ticket-stopover.component.scss']
})
export class INDRATicketStopoverComponent implements OnInit, OnChanges, OnDestroy {
	@Input()
	stopover;

	@Input()
	extras;

	@Input()
	loading_extras: boolean;

	@Input()
	readOnly: boolean = false;

	@Output()
	addFeature = new EventEmitter();

	@Output()
	detailsFeature = new EventEmitter();

	bookedTripExtras$: Observable<any> = this.store.select(fromStore.getSelectedBookedTripExtras);
	selectedExtras: any[];

	isAlive = true;
	destinationLogo;
	destinationImage;

	APPLICABLE_ALL = 'ALL';
	features: any[];

	currency;

	STOPOVER_LINKS = [
		//{
		//	id: 'hotel',
		//	label: 'bookingDetails.alt.stopOverLinksAddHotel',
		//	description: '',
		//	type: 'extra',
		//	action: { label: 'Add', route: 'partner-hotel' },
		//	icon: 'services--book_hotel',
		//	active: false,
		//	name: EXTRAS_ANCILLARY_STOPOVER_HOTEL
		//},
		{
			id: 'hotel-info',
			label: 'bookingDetails.title.hotelInfo',
			description: '',
			type: 'extra',
			action: { label: 'bookingDetails.button.learnMore', route: 'partner-hotel-info' },
			icon: 'services--book_hotel',
			active: false,
			name: EXTRAS_ANCILLARY_STOPOVER_HOTEL
		},
		{
			id: 'lisboa-card',
			label: 'bookingDetails.title.lisboaCard',
			description: '',
			type: 'extra',
			action: { label: 'bookingDetails.button.add', route: 'lisboa-card-discount' },
			icon: 'money_related--seat_discount',
			active: false,
			name: EXTRAS_ANCILLARY_STOPOVER_LISBOA_CARD
		},
		{
			id: 'sightseeing-tours',
			label: 'bookingDetails.title.sightseeingTours',
			description: '',
			type: 'extra',
			action: { label: 'bookingDetails.button.add', route: 'sightseeing-tours' },
			icon: 'destinations--tours_activities',
			active: false,
			name: EXTRAS_ANCILLARY_STOPOVER_SIGHTSEEING_TOURS
		},
		{
			id: 'airport-transfers',
			label: 'bookingDetails.title.airportTransfers',
			description: '',
			type: 'extra',
			action: { label: 'bookingDetails.button.add', route: 'airport-transfers' },
			icon: 'transportation--bus',
			active: false,
			name: EXTRAS_ANCILLARY_STOPOVER_AIRPORT_TRANSFERS
		},
	];
	constructor(
		private mybService: INDRAMybService,
		private ibeAdminService: INDRAIbeAdminService,
		private ibeAdminConfigService: INDRAIbeAdminConfigService,
		private currencyService: INDRACurrencyService,
		private store: Store<fromStore.State>,
		private googleAnalytics: INDRAGoogleAnalyticsService,
	) {
		this.currency = this.currencyService.INDRA_getCurrencySymbol().name;

		this.bookedTripExtras$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value) {
					this.selectedExtras = value;
					this.INDRA_mapAddedStopoverExtras();
				}
			});
	}

	ngOnInit() {
		if (this.selectedExtras) {
			this.INDRA_mapAddedStopoverExtras();
		}

	}

	ngOnDestroy() {
		this.isAlive = false;
	}


	INDRA_isActive(stopover) {
		return stopover.active;
	}

	/**
	 * Returns list of features
	 * @returns list of features
	 */
	INDRA_getFeatures() {
		return this.features;
	}
	/**
	 * Returns if feature has an icon to show
	 * @param feature
	 */
	INDRA_hasIcon(feature) {
		return feature.icon != null;
	}

	/**
	 * Emits the @action of the feature to the parent
	 * @param action
	 */
	INDRA_handleOpenExtra(action: { route: string }, mode: string, featureName) {
		const selectedExtra = this.extras.filter(extra => extra.ancillaryList[0].type === featureName);

		action = Object.assign({}, action, {
			city: this.stopover['destination'],
			action: mode,
			selectedExtra: selectedExtra,
			stopoverCode: this.stopover.code
		});
		this.addFeature.emit(action);
		this.INDRA_registerGAStopoverExtra(action);
	}

	INDRA_registerGAStopoverExtra(param) {

		let brand;
		const amount = param.selectedExtra[0].amount;
		let extra = {
			amount: amount
		};

		brand = EVENT_PRODUCT_BRAND_HOTELS;
		extra['bookableItemId'] = param.selectedExtra[0].ancillaryList[0].itemId;
		extra['description'] = param.selectedExtra[0].name;


		let eventDataLayerObject = this.googleAnalytics.INDRA_createGA_ExternalAncillarySingleProduct(brand, extra);
		eventDataLayerObject.actionField = this.googleAnalytics.INDRA_createGA_ActionField(EVENT_ACTION_CLICK);

		this.googleAnalytics.INDRA_GA_productClick(eventDataLayerObject, sessionStorage.getItem(SESSION_VAR_KEY_CURRENCY));
	}

	/**
	 * Emits the @details of the feature to the parent
	 * @param details
	 */
	INDRA_handleOpenExtraDetails(details: { route: string }) {
		// this.detailsFeature.emit(details);
	}

	/**
	 * Prints number of stopover days (plural or singular)
	 */
	INDRA_printDaysCount() {
		return this.stopover.days;
	}

	/**
	 * Prints number of stopover days (plural or singular)
	 */
	INDRA_printDaysLabel() {
		if (this.stopover.days === 1) {
			return 'bookingDetails.label.dayStopoverIn';
		} else {
			return 'bookingDetails.label.daysStopoverIn';
		}
	}

	/**
	 * Prints formated destination name
	 */
	INDRA_printStopoverDestination() {
		return this.stopover.destination && this.stopover.destination.charAt(0).toUpperCase() + this.stopover.destination.slice(1);
	}

	/**
	 * Get destination banner image from service
	 */
	INDRA_printDestinationImage() {
		return this.mybService.INDRA_printDestinationImage(this.stopover.code);
	}

	/**
	 * Get destination text logo from service
	 */
	INDRA_printDestinationLogo() {
		return this.mybService.INDRA_printDestinationLogo(this.stopover.code);
	}

	/**
	 * Get Stopover aria label
	 */
	INDRA_printAriaStopover() {
		let label = '';
		if (this.stopover.days === 1) {
			label += this.stopover.days + this.INDRA_getTextTranslation('bookingDetails.aria.dayPortugalStopoverIn');
		} else {
			label += this.stopover.days + this.INDRA_getTextTranslation('bookingDetails.aria.daysPortugalStopoverIn');
		}
		label += this.stopover.destination;
		return label;
	}

	INDRA_getTranslationAsync(key: string): Observable<string> {
		return this.ibeAdminService.getTranslationValueAsync(key);
	}

	INDRA_getTextTranslation(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}

	INDRA_goToUrl(key: string) {
		if (key === 'externalURLs.stopOverHotel') {
			const label = 'airtap-stopover-blogo';
			const sid = '45335db886613e4157a1148db0892322';
			const sb = 1;
			const src = 'index';
			const src_elem = 'sb';
			const error_url = 'https%3A%2F%2Fhotels.flytap.com%2Findex.es.html%3Faid%3D1175179%3Blabel%3Dairtap-stopover-blogo%3Bsid%3D45335db886613e4157a1148db0892322%3Bsb_price_type%3Dtotal%26%3B';
			const ss = this.INDRA_printStopoverDestination();
			const is_ski_area = 0;
			const checkin_year = 2019;
			const checkin_month = 12;
			const checkin_monthday = 25;
			const checkout_year = 2019;
			const checkout_month = 12;
			const checkout_monthday = 26;
			const group_adults = 2;
			const group_children = 0;
			const no_rooms = 1;
			const from_sf = 1;
			const lang = sessionStorage.getItem('language').toLowerCase();
			const selected_currency = sessionStorage.getItem('currency');

			const urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(key);
			const urlNavigate = urlIbeAdmin.replace('${label}', `${label}`)
				.replace('${sid}', `${sid}`)
				.replace('${sb}', `${sb}`)
				.replace('${src}', `${src}`)
				.replace('${src_elem}', `${src_elem}`)
				.replace('${error_url}', `${error_url}`)
				.replace('${ss}', `${ss}`)
				.replace('${is_ski_area}', `${is_ski_area}`)
				.replace('${checkin_year}', `${checkin_year}`)
				.replace('${checkin_month}', `${checkin_month}`)
				.replace('${checkin_monthday}', `${checkin_monthday}`)
				.replace('${checkout_year}', `${checkout_year}`)
				.replace('${checkout_month}', `${checkout_month}`)
				.replace('${checkout_monthday}', `${checkout_monthday}`)
				.replace('${group_adults}', `${group_adults}`)
				.replace('${group_children}', `${group_children}`)
				.replace('${no_rooms}', `${no_rooms}`)
				.replace('${from_sf}', `${from_sf}`)
				.replace('${lang}', `${lang}`)
				.replace('${selected_currency}', `${selected_currency}`);
			window.open(urlNavigate);
		} else if (key === 'externalURLs.stopOverCar') {
			const pickupDateTime = '2019-05-24T103A00';
			const returnDateTime = '2019-05-26T123A00';
			const age = 30;
			const clientID = 635309;
			const ct = 'MP';
			const curr = sessionStorage.getItem('currency');
			const elID = 811558433713890;
			const residenceID = 'ES';
			const pickupID = 2640;
			const pickupName = 'Lisboa';
			const returnID = 2640;
			const returnName = 'Lisboa20-20Aeroporto';
			const lang = sessionStorage.getItem('language').toLowerCase();
			const urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(key);
			const urlNavigate = urlIbeAdmin.replace('${pickupDateTime}', `${pickupDateTime}`)
				.replace('${returnDateTime}', `${returnDateTime}`)
				.replace('${age}', `${age}`)
				.replace('${clientID}', `${clientID}`)
				.replace('${ct}', `${ct}`)
				.replace('${curr}', `${curr}`)
				.replace('${elID}', `${elID}`)
				.replace('${residenceID}', `${residenceID}`)
				.replace('${pickupID}', `${pickupID}`)
				.replace('${pickupName}', `${pickupName}`)
				.replace('${returnID}', `${returnID}`)
				.replace('${returnName}', `${returnName}`)
				.replace('${lang}', `${lang}`);
			return window.open(urlNavigate);
		} else {
			const languageCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
								sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE).toLowerCase() : DEFAULT_LANGUAGE;
			const languageMap = SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] ? SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] : languageCode;
			const marketCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
									sessionStorage.getItem(SESSION_VAR_KEY_MARKET).toLowerCase() : DEFAULT_MARKET;
			const urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(key);
			const urlNavigate = urlIbeAdmin.replace('${lang}', `${languageMap}`).replace('${market}', `${marketCode}`);
			return window.open(urlNavigate);
		}

	}

	INDRA_getStopoverHashtag() {
		let stopoverHashtag = '';
		switch (this.stopover.countryCode) {
			case COUNTRY_CODE_PORTUGAL:
				stopoverHashtag =  '#PortugalStopover'; break;
			case COUNTRY_CODE_BRAZIL:
				stopoverHashtag =  '#BrazilStopover'; break;
			default: break;
		}
		return stopoverHashtag;
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes['extras']) {
			const extrasLoaded = changes['extras'];
			if (extrasLoaded && this.extras) {
				this.features = this.STOPOVER_LINKS.filter(
					val => this.extras.some(extra => extra.ancillaryList[0].type === val.name));
			}
		}

		if (changes['readOnly']) {
			if (this.extras && changes['readOnly'].currentValue) {
				this.INDRA_setToActiveReadOnly();
			}
		}
	}

	INDRA_mapAddedStopoverExtras() {
		if (this.features && this.features.length) {
			this.features.map(cur => {
				cur.active = false;

				const findExtra = this.selectedExtras.find(extra => extra.type == cur.id);
				if (findExtra) {
					if (findExtra.stopoverHotel) {
						for (const i in findExtra.data) {
							if (this.stopover.destination == findExtra.data[i].routeParam.city) {
								cur.active = true;
								cur.value = findExtra.data[i].value;
							}
						}
					} else {
						const nonHotelExtras = this.selectedExtras.find(extra => extra.type == cur.id && extra.stopoverCity == this.stopover.code);
						if (findExtra) {
							cur.active = true;
							cur.value = nonHotelExtras.value;
						}
					}
				}
				return cur;
			});
		}
	}

	INDRA_setToActiveReadOnly() {
		this.features.forEach(feature => {
			feature.active = true;
		});
	}
}
